import { KeyValueStorageInterface } from 'aws-amplify/utils';
import { getCookie, setCookie, removeCookie } from 'typescript-cookie'
import { environment } from '../../../environments/environment';

export type Tool = 'GAMEFACE' | 'GREAT_MINDS' | 'PACT' | 'LOOPED_IN' ;


export class User {

  id?: string ;
  givenName: string ;
  familyName: string ;
  email: string;
  profileImage?: string ;
  bio?: string;
  guest: boolean = false ;
  
  constructor(id: string | undefined, givenName: string, familyName: string, email: string) {
    this.id = id;
    this.givenName = givenName ;
    this.familyName = familyName ;
    this.email = email;    
  }

  static buildFromSession(session: any): User | undefined{

    const accessToken: any = session?.tokens?.accessToken ;
    const idToken: any = session?.tokens?.idToken ;
    if (!idToken || !accessToken) {
      return undefined ;
    }

    const user = new User(
      accessToken.payload.username, 
      idToken.payload.given_name, 
      idToken.payload.family_name,
      idToken.payload.email
    )
    user.profileImage = idToken.payload.picture ;
    user.bio = idToken.payload.profile ;
    return user ;
  }
}

export interface Guest {
  user: User ;
  token: string ;
  expiresAt: Date ;
}

export interface ContractStatus {
  underContract: boolean;
  tools: Tool[];
  endsAt: Date | null;
}

export class CognitoTokenStorage implements KeyValueStorageInterface {

  
  async setItem(key: string, value: string): Promise<void> {
    //console.log("Setting cookie", key, value) ;

    setCookie(key, value, {domain:environment.cookieDomain, path:'/'}) ;
  }
  async getItem(key: string): Promise<string | null> {
    
    const value = getCookie(key) ;
    //console.log("getting cookie", key, value) ;
    if (value) {
      return value ;
    } else {
      return null ;
    }
  }
  async removeItem(key: string): Promise<void> {
    //console.log("removing cookie", key) ;
    removeCookie(key, { domain: environment.cookieDomain, path:'/' })
  }

  async clear(): Promise<void> {

    console.log("Clearing cookies") ;

    const allCookies = document.cookie.split(';');
    for (const cookie of allCookies) {
      const cookieName = cookie.split('=')[0].trim();
      console.log("removing cookie", cookieName);
      if(cookieName) {
        removeCookie(cookieName);
      }
    }
  }
}


